// Selskapsinfo-API mot workerens /selskapsinfo-endepunkter (admin-gated; token settes
// av apiClient). Veksler til fixtures når VITE_USE_MOCKS er på — samme mønster som adminApi.ts.
import { apiClient } from "@/lib/apiClient";
import { env } from "@/lib/env";
import { selskapsinfoFixtures } from "../mocks/fixtures";
import type { BrregResponse, CompanyHit, ExposureResponse, PengestromResponse } from "./types";

export interface SelskapsinfoApi {
  search(q: string): Promise<CompanyHit[]>;
  brreg(orgnr: string): Promise<BrregResponse>;
  eksponering(orgnr: string): Promise<ExposureResponse>;
  pengestrom(orgnr: string): Promise<PengestromResponse>;
}

const realApi: SelskapsinfoApi = {
  async search(q) {
    const r = await apiClient.get<{ ok: true; hits: CompanyHit[] }>(
      `/selskapsinfo/search?q=${encodeURIComponent(q)}`
    );
    return r.hits;
  },
  async brreg(orgnr) {
    const r = await apiClient.get<{ ok: true } & BrregResponse>(`/selskapsinfo/${orgnr}/brreg`);
    return r;
  },
  async eksponering(orgnr) {
    const r = await apiClient.get<{ ok: true } & ExposureResponse>(
      `/selskapsinfo/${orgnr}/eksponering`
    );
    return r;
  },
  async pengestrom(orgnr) {
    const r = await apiClient.get<{ ok: true } & PengestromResponse>(
      `/selskapsinfo/${orgnr}/pengestrom`
    );
    return r;
  },
};

export const selskapsinfoApi: SelskapsinfoApi = env.useMocks ? selskapsinfoFixtures : realApi;
